import { AddKeywordsPageData, SerpGeoLocation, SerpProjectKeyword, SerpSearchEngine } from '@hydra/types/serp';
import isEmpty from 'lodash/isEmpty';

export function getKeywordTagsByKeywordMap ({ projectKeywords }: {
  projectKeywords: {[key: string]: SerpProjectKeyword}
}) {
  if (!projectKeywords) {
    return {};
  }

  return Object.values(projectKeywords).reduce(
    (map, keyword) => {
      return Object.assign(map, { [keyword.kwId]: keyword.projectKeywordTags });
    },
    {}
  );
}

export const getLastAddedKeyword = (state: AddKeywordsPageData): SerpProjectKeyword | SerpSearchEngine => {
  if (!state || !state.projectKeywords || isEmpty(state.projectKeywords)) {
    return {
      country: 'us',
      language: 'en'
    };
  }

  const sortedKeywords = Object.values(state.projectKeywords).sort((a, b) => {
    return new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf();
  });
  return sortedKeywords[0];
};

export const getCurrentSearchEngineKeywords = ({ keywords, searchEngine, geoLocation }: {
  keywords: SerpProjectKeyword[]
  searchEngine: SerpSearchEngine
  geoLocation: SerpGeoLocation
}) => {
  const { country, language } = searchEngine;
  const { locName = null, locType = null } = geoLocation;

  const filterKeywords = (keyword: SerpProjectKeyword) => {
    return keyword.country === country &&
      (language ? keyword.language === language : keyword.language === 'default') &&
      keyword.locName === locName &&
      keyword.locType === locType;
  };

  return Object.values(keywords).filter(filterKeywords).map(({ keyword }) => keyword);
};
